// src/data/routingKeyToCounty.ts
// Maps Irish Eircode routing keys (e.g. D01, D02, A94) to counties for SEO and display enrichment.
// Note: Mappings are based on the primary county of the Routing Key's principal post town.
// Some keys (e.g. V94, A86, N37) geographically cross county borders.

export const routingKeyToCounty: Record<string, string> = {
  // --- Dublin (City & County) ---
  D01: 'Dublin',
  D02: 'Dublin',
  D03: 'Dublin',
  D04: 'Dublin',
  D05: 'Dublin',
  D06: 'Dublin',
  D06W: 'Dublin',
  D07: 'Dublin',
  D08: 'Dublin',
  D09: 'Dublin',
  D10: 'Dublin',
  D11: 'Dublin',
  D12: 'Dublin',
  D13: 'Dublin',
  D14: 'Dublin',
  D15: 'Dublin',
  D16: 'Dublin',
  D17: 'Dublin',
  D18: 'Dublin',
  D20: 'Dublin',
  D22: 'Dublin',
  D24: 'Dublin',
  // North Co. Dublin (Fingal)
  K32: 'Dublin', // Balbriggan
  K34: 'Dublin', // Skerries
  K36: 'Dublin', // Rush
  K45: 'Dublin', // Lusk
  K56: 'Dublin', // Swords
  K67: 'Dublin', // Malahide
  K78: 'Dublin', // Lucan
  A41: 'Dublin', // Ballyboughal
  A42: 'Dublin', // Garristown
  A45: 'Dublin', // Oldtown
  // South Co. Dublin
  A94: 'Dublin', // Blackrock
  A96: 'Dublin', // Glenageary
  A99: 'Dublin', // Shankill

  // --- Cork ---
  // Cork City
  T12: 'Cork',
  T23: 'Cork',
  // Cork County
  P12: 'Cork', // Macroom
  P14: 'Cork', // Crookstown
  P17: 'Cork', // Kinsale
  P24: 'Cork', // Cobh
  P25: 'Cork', // Midleton
  P31: 'Cork', // Ballincollig
  P32: 'Cork', // Rylane
  P36: 'Cork', // Youghal
  P43: 'Cork', // Carrigaline
  P47: 'Cork', // Dunmanway
  P51: 'Cork', // Mallow
  P56: 'Cork', // Charleville
  P61: 'Cork', // Fermoy
  P67: 'Cork', // Mitchelstown
  P72: 'Cork', // Bandon
  P75: 'Cork', // Bantry
  P81: 'Cork', // Skibbereen
  P85: 'Cork', // Clonakilty
  T45: 'Cork', // Glanmire
  T56: 'Cork', // Watergrasshill

  // --- Galway ---
  H91: 'Galway', // Galway City
  H53: 'Galway', // Ballinasloe
  H54: 'Galway', // Tuam
  H62: 'Galway', // Loughrea
  H65: 'Galway', // Athenry
  H71: 'Galway', // Clifden

  // --- Limerick ---
  V94: 'Limerick', // Limerick City (Note: Covers parts of Clare)
  V35: 'Limerick', // Kilmallock
  V42: 'Limerick', // Newcastle West

  // --- Waterford ---
  X91: 'Waterford', // Waterford City
  X35: 'Waterford', // Dungarvan
  X42: 'Waterford', // Kilmacthomas

  // --- Kildare ---
  W12: 'Kildare', // Newbridge
  W23: 'Kildare', // Celbridge
  W34: 'Kildare', // Monasterevin
  W91: 'Kildare', // Naas
  R14: 'Kildare', // Athy
  R51: 'Kildare', // Kildare Town
  R56: 'Kildare', // Curragh

  // --- Meath ---
  C15: 'Meath', // Navan
  A82: 'Meath', // Kells
  A83: 'Meath', // Enfield
  A84: 'Meath', // Ashbourne
  A85: 'Meath', // Dunshaughlin
  A86: 'Meath', // Dunboyne

  // --- Wicklow ---
  A63: 'Wicklow', // Greystones
  A67: 'Wicklow', // Wicklow Town
  A98: 'Wicklow', // Bray (Note: Covers parts of Dublin border)
  Y14: 'Wicklow', // Arklow (Note: Uses 'Y' but is in Wicklow)

  // --- Wexford ---
  Y21: 'Wexford', // Enniscorthy
  Y25: 'Wexford', // Gorey
  Y34: 'Wexford', // New Ross
  Y35: 'Wexford', // Bunclody

  // --- Kerry ---
  V92: 'Kerry', // Tralee
  V93: 'Kerry', // Killarney
  V23: 'Kerry', // Cahersiveen
  V31: 'Kerry', // Listowel

  // --- Mayo ---
  F12: 'Mayo', // Claremorris
  F23: 'Mayo', // Castlebar
  F26: 'Mayo', // Ballina
  F28: 'Mayo', // Westport
  F31: 'Mayo', // Ballinrobe
  F35: 'Mayo', // Ballyhaunis

  // --- Donegal ---
  F92: 'Donegal', // Letterkenny
  F93: 'Donegal', // Lifford
  F94: 'Donegal', // Donegal Town

  // --- Tipperary ---
  E21: 'Tipperary', // Cahir
  E25: 'Tipperary', // Cashel
  E32: 'Tipperary', // Carrick-on-Suir
  E34: 'Tipperary', // Tipperary Town
  E41: 'Tipperary', // Thurles
  E45: 'Tipperary', // Nenagh
  E53: 'Tipperary', // Roscrea
  E91: 'Tipperary', // Clonmel

  // --- Clare ---
  V95: 'Clare', // Ennis
  V14: 'Clare', // Shannon
  V15: 'Clare', // Kilrush

  // --- Louth ---
  A91: 'Louth', // Dundalk
  A92: 'Louth', // Drogheda

  // --- Kilkenny ---
  R95: 'Kilkenny', // Kilkenny City

  // --- Carlow ---
  R93: 'Carlow', // Carlow Town
  R21: 'Carlow', // Bagenalstown

  // --- Laois ---
  R32: 'Laois', // Portlaoise

  // --- Offaly ---
  R35: 'Offaly', // Tullamore
  R42: 'Offaly', // Birr
  R45: 'Offaly', // Edenderry

  // --- Westmeath ---
  N37: 'Westmeath', // Athlone (Note: Covers parts of Roscommon)
  N91: 'Westmeath', // Mullingar

  // --- Longford ---
  N39: 'Longford', // Longford Town

  // --- Roscommon ---
  F42: 'Roscommon', // Roscommon Town
  F45: 'Roscommon', // Castlerea
  F52: 'Roscommon', // Boyle

  // --- Sligo ---
  F91: 'Sligo', // Sligo Town
  F56: 'Sligo', // Ballymote

  // --- Cavan ---
  H12: 'Cavan', // Cavan Town
  H14: 'Cavan', // Belturbet
  H16: 'Cavan', // Cootehill

  // --- Monaghan ---
  H18: 'Monaghan', // Monaghan Town
  H23: 'Monaghan', // Clones
  A75: 'Monaghan', // Castleblayney
  A81: 'Monaghan', // Carrickmacross

  // --- Leitrim ---
  N41: 'Leitrim' // Carrick-on-Shannon
};
// Note: Some routing keys may not be included if they are less commonly used or cover very small areas.